import Link from "@mui/material/Link"
import { ReactElement } from "react"

import { AppCard, AppCardContent, AppCardHeader } from "../../surfaces/appCard"

interface IDupeAssessmentProps {
    duplicateApplications: string[] | undefined
}

/**
 * Displays a checkbox table showing output of ENA assessment. This is schema
 * agnostic, only assuming the assessment is of type `IEnaAssessmentProps`
 */
const DuplicateApplications = ({
    duplicateApplications,
}: IDupeAssessmentProps): ReactElement => (
    <AppCard>
        <AppCardHeader
            title="Duplicate Applications"
            subheader="Click any of the links below to view the application"
            titleTypographyProps={{
                variant: "h5",
                fontWeight: "500",
            }}
        />
        <AppCardContent>
            {duplicateApplications &&
                duplicateApplications.map((application) => (
                    <Link
                        href={`/dno-application/${application}`}
                        underline="hover"
                        color="primary"
                        sx={{ display: "block", mb: 1 }}
                        key={application}
                    >
                        {application}
                    </Link>
                ))}
        </AppCardContent>
    </AppCard>
)

export default DuplicateApplications
